module.exports = __webpack_public_path__ + "static/media/KMH_4975.47a73c45.jpg";